import * as React from "react"

const SvgComponent = (props) => (
  <svg
    width={20}
    height={20}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M10 0C4.462 0 0 4.462 0 10s4.462 10 10 10 10-4.462 10-10S15.538 0 10 0Z"
      fill="#8DD6FF"
    />
    <path
      d="m13.22 8.756-2.112-2.112.504-.503 2.11 2.11-.503.505ZM7.596 14.38l-2.11-2.11 5.255-5.254 2.11 2.111-5.255 5.254ZM14.553 7.444a.86.86 0 0 0 0-1.221l-.882-.883c-.34-.339-.916-.339-1.222 0l-.44.442 2.137 2.137.407-.475ZM4.274 15.248a.264.264 0 0 0 .068.271.259.259 0 0 0 .17.068h.101l2.545-.916-1.968-1.968-.916 2.545Z"
      fill="#fff"
    />
  </svg>
)

export default SvgComponent